<template>
  <v-container fluid>
    <v-alert
      :value="true"
      type="warning"
      v-if="imports.length ===0 && !loading"
    >
      No Import Data available.
    </v-alert>
    <v-list three-line
            v-if="imports.length > 0">
      <template v-for="(item, index) in imports">
        <v-list-tile
          :key="item.id"
          :to="{ name: 'import_view', params: { id: item.id }}"
          avatar
          ripple
        >
          <v-list-tile-content>
            <v-list-tile-title>Import started at {{ item.created_at }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <v-chip color="green darken-3" text-color="white">
                <v-avatar>
                  <v-icon>check_circle</v-icon>
                </v-avatar>
                for {{ item.entities_count }} entities
              </v-chip>
            </v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-divider
          v-if="index + 1 < imports.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import _ from 'underscore'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    data () {
      return {
        selected: null,
        info: null,
        loading: true,
        imports: [],
        errored: false,
        searchTimeout: null,
      }
    },
    mounted () {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      this.$emit('TriggerLoading', true)
      axios
      .get(`${Config.API_URL}/imports`)
       .then(response => {
        this.imports = response.data
        this.loading = false
        this.$emit('TriggerLoading', false)
      })
       .catch(error => {
        this.loading = false
        console.log(error)
        this.errored = true
      })
    },
  }
</script>
